export const paymentHotCurrency = [
  {
    id: 'GBP',
    text: 'GBP',
  },
  {
    id: 'EUR',
    text: 'EUR',
  },
  {
    id: 'USD',
    text: 'USD',
  },
];
